import { useShare } from 'app/features/sharing/hooks'
import { copyToClipboard } from 'app/lib/copy-to-clipboard'
import { useState } from 'react'
import { ShareLinkBlock } from './share-link.block'
import { ShareLinkComponent } from './share-link.component'

export const ShareLinkContainer = (block: ShareLinkBlock) => {
  const { onShare } = useShare({ href: block.shareLink })
  const [isCopied, setIsCopied] = useState(false)

  return (
    <ShareLinkComponent
      {...block}
      copied={isCopied}
      onCopyLink={() => {
        copyToClipboard(block.shareLink!)

        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 4000)
      }}
      onShare={onShare}
    />
  )
}
